<template>
  <div class="mdl-grid mdl-grid--no-spacing line-gauge-container">
    <div class="mdl-cell mdl-cell--middle lg-box">
      <LineGauge v-bind:value="value" v-bind:bg-color="bgColor"></LineGauge>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'progress-bar',

    props: {
      value: {
        type: Number,
        default: 50,
      },
      bgColor: {
        type: String,
        default: '#00c896',
      },
    },
  };
</script>

<style lang="scss">
  .line-gauge-container {
    position: relative;
    height: 18px;

    .lg-label {
      width: 30%;
      line-height: 18px;
    }

    .lg-box {
      width: 100%;
    }

    .lg-position-num {
      width: 13%;
      line-height: 18px;
      text-align: right;
      font-weight: 500;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue